import { createStore } from "vuex";
import axios from "axios";
import router from "@/router";
export default createStore({
  state: { isLogin: false, token: "" },
  mutations: {
    Login(state, token) {
      if (token) {
        state.isLogin = true;
        state.token = token;
        localStorage.setItem("token", token);
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      } else {
        state.isLogin = false;
        state.token = "";
        localStorage.removeItem("token");
        axios.defaults.headers.common["Authorization"] = "";
      }
    },
    Logout(state) {
      state.isLogin = false;
      state.token = "";
      localStorage.removeItem("token");
      axios.defaults.headers.common["Authorization"] = "";
      router.push({ name: "login" });
    },
  },
  actions: {
    OnRouteChange() {
      const token = localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        axios
          .get("/users/check")
          .then(() => {
            this.commit("Login", token);
          })
          .catch((error) => {
            console.log(error);
            this.commit("Logout");
          });
      } else {
        this.commit("Logout");
      }
    },
  },
});
